import { GrapeListProvider } from "../../components/GrapeList/context/GrapeListProvider";
import { GrapeListForm } from "../../components/GrapeList/GrapeListForm";

export const AddGrapeList = ({ searchText }) => {
	return (
		<GrapeListProvider>
			<GrapeListForm mode="add" />
		</GrapeListProvider>
	);
};
